(ns frontend.view.modals.copy-permissions.view
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :copy-permissions-modal)

(defn copy-from-selector
  [state options]
  [labelled-input/view
   {:editor-type :editor.type/select
    :value       (->> options
                      (cu/filter-by :value (get @state :copy-from))
                      (first))
    :options     options
    :label       (loc/tr :copy-from)
    :on-change   (fn [o]
                   (swap! state assoc :copy-from o))}])

(defn copy-to-selector
  [state options]
  [labelled-input/view
   {:editor-type :editor.type/select
    :value       (->> options
                      (cu/filter-by :value (get @state :copy-to))
                      (first))
    :options     (->> options
                      (cu/remove-by :value (get @state :copy-from)))
    :label       (loc/tr :copy-to)
    :on-change   (fn [o]
                   (swap! state assoc :copy-to o))}])

(defn view
  [{:keys [props state]}]
  (let [{:keys [default-source]} props]
    (swap! state assoc :copy-from default-source)
    (fn [{:keys [shown? close-modal! props state topmost?]}]
      (let [{:keys [options on-submit!]} props
            on-close! (fn []
                        (close-modal!))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :copy-permissions-modal-title)
         [:div
          {:class "flex flex-column gap-2"}
          [copy-from-selector state options]
          [copy-to-selector state options]]
         (let [form-ready? (and (:copy-from @state)
                                (:copy-to @state)
                                (not= (:copy-from @state)
                                      (:copy-to @state)))]
           [modal/right-single-button
            nil
            (not form-ready?)
            (fn [_]
              (on-submit! (:copy-from @state) (:copy-to @state) on-close!))
            (loc/tr :copy)
            nil])]))))
